import { AccountTeam } from '../../enums/AccountTeam.enum'
import { ApprovalStatus } from '../../enums/ApprovalStatus.enum'
import { LeaveRequestSource } from '../../enums/LeaveRequestSource.enum'
import { LeaveTime } from '../../enums/LeaveTime.enum'
import { LeaveType } from '../../enums/LeaveType.enum'
import { LeaveRequest, LeaveRequestRaw } from '../LeaveRequest'

function fromRaw({ id, rawData }: { id: string; rawData: LeaveRequestRaw }): LeaveRequest {
  return {
    id,
    source: rawData.source as LeaveRequestSource,
    approvalStatus: rawData.approvalStatus as ApprovalStatus,
    name: rawData.name,
    email: rawData.email,
    accountTeam: rawData.accountTeam as AccountTeam,
    position: rawData.position,
    startDate: rawData.startDate.toDate(),
    startDateString: rawData.startDateString ?? null,
    endDate: rawData.endDate.toDate(),
    endDateString: rawData.endDateString ?? null,
    leaveTime: rawData.leaveTime as LeaveTime,
    leaveType: rawData.leaveType as LeaveType,
    otherLeaveType: rawData.otherLeaveType ?? '',
    supportingDocumentRef: !!rawData.supportingDocumentRef ? rawData.supportingDocumentRef : null,
    supportingDocumentUrl: !!rawData.supportingDocumentUrl ? rawData.supportingDocumentUrl : null,
    reason: rawData.reason ?? '',
    createdAt: !!rawData.createdAt ? rawData.createdAt.toDate() : null,
    approvalUpdatedAt: !!rawData.approvalUpdatedAt ? rawData.approvalUpdatedAt.toDate() : null,
    approvalBy: rawData.approvalBy,
  }
}

const LeaveRequestTableHelper = {
  fromRaw,
}

export default LeaveRequestTableHelper
